import { TenderConfig } from '@rygen/rygen-ui/model';

export class BulkTenderRequest {
  shipmentIds?: number[];
  scac?: string;
  tenderConfig?: TenderConfig;

  constructor(opts?: Partial<BulkTenderRequest>) {
    if (opts?.shipmentIds != null) {
      this.shipmentIds = opts.shipmentIds;
    }
    if (opts?.scac != null) {
      this.scac = opts.scac;
    }
    if (opts?.tenderConfig != null) {
      this.tenderConfig = new TenderConfig(opts.tenderConfig);
    }
  }
}
